import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { Grid, Paper, Box, Button, Alert } from "@mui/material";
import { useUser } from '../../context/UserContext';
import {forgotUserName} from '../../api/authService';




export default function ForgotUsername() {
  const [mobileNumber, setEmail] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const {updateUser} = useUser();
  const [userMobile, setUserMobile] = useState("");
  

  const handleChange = (e) => {
    setUserMobile(e.target.value);
    setError(""); // Clear previous error message
    const { name, value } = e.target;
    setEmail(e.target.value);
    updateUser(name, value); // Dynamically update the field
  };

  const handleCancel = () => {
    setUserMobile(""); // Clear the Mobile field
    setError(""); // Clear the error message
    navigate('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Simulate API call
      const { response, data } = await forgotUserName(mobileNumber);     
      
      console.log("Forgot Username :", data, response, data.email);


      if (response.ok) {
        updateUser("email", data.email);
        setSuccess("Email sent successfully!");
        navigate("/ValidateOTP"); // Route to ValidateOTP
      } else {
        setError(response.message || "Invalid Mobile #. Member does not exist with this Mobile #");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }

  };
  
  return (
    <>
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="#f9f9f9"
      >
        <div style={{ padding: "20px" }}>
          <h2>Forgot Username</h2>
          <h4>
            Enter the Mobile Number associated with your account and we'll send you
            an OTP along with your username to reset your password.
          </h4>
          <form onSubmit={handleSubmit}>
            <Grid item xs={12} sm={6}>
              <Paper elevation={3}>
                <TextField
                  required
                  id="mobile"
                  label="Mobile Phone"
                  name="mobileNumber"
                  variant="outlined"
                  fullWidth
                  value={userMobile}
                  onChange={handleChange}
                />
              </Paper>
            </Grid>

            <br />

            <div>
              <br />
            </div>
            <Grid container spacing={2} justifyContent="center" >
              <Grid item>
                <Button variant="contained" color="primary" onClick={handleCancel} sx={{ mr: 4 }}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button type="submit" variant="contained" color="primary" >
                  Email Me the OTP
                </Button>
              </Grid>
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Alert severity="error">{error}</Alert>
              </Grid>
            )}
            {success && (
              <Grid item xs={12} style={{ marginTop: '16px' }}>
                <Alert severity="success">{success}</Alert>
              </Grid>
            )}
          </form>
        </div>
      </Box>
    </>
  );
}
